module.exports = __webpack_public_path__ + "static/img/icon2-active.63a74d7b.svg";